import axios from "axios";
import { createPaginatedStateWithSummary, handlePaginatedResponse,createPaginatedState } from '../helpers/paginationState';

export const state = {
    save_status: false,
    filter_status: false,
    recipes: createPaginatedState(),
    recipes_cart: [],
    expected_output: [],
    actual_output: [],
    production_order_cart: [],
    production_orders: createPaginatedStateWithSummary(50),
};
export const getters = {
    SaveStatus: state => state.save_status,
    filterStatus: state => state.filter_status,
    Recipes: state => state.recipes.data,
    RecipesPagination: state => state.recipes.meta,
    RecipesPaginated: state => state.recipes.data,
    IsRecipesServerPaginated: state => state.recipes.isServerPaginated,
    RecipesCart: state => state.recipes_cart.data,
    ExpectedOutput: state => state.expected_output.data,
    ExpectedOutputPagination: state => state.expected_output.meta,
    ExpectedOutputPaginated: state => state.expected_output.data,
    IsExpectedOutputServerPaginated: state => state.expected_output.isServerPaginated,
    ActualOutput: state => state.actual_output.data,
    ActualOutputPagination: state => state.actual_output.meta,
    ActualOutputPaginated: state => state.actual_output.data,
    IsActualOutputServerPaginated: state => state.actual_output.isServerPaginated,
    ProductionOrderCart: state => state.production_order_cart.data,
    ProductionOrders: state => state.production_orders.data,
    ProductionOrdersPagination: state => state.production_orders.meta,
    ProductionOrdersPaginated: state => state.production_orders.data,
    IsProductionOrdersServerPaginated: state => state.production_orders.isServerPaginated,
    
};

export const mutations = {
    SET_SAVE_STATUS(state, newValue) {
        state.save_status = newValue
    },
    SET_FILTER_STATUS(state, newValue) {
        state.filter_status = newValue
    },
    SET_RECIPE(state, response) {
        handlePaginatedResponse(state.recipes, response);
    },
    SET_RECIPE_CART(state, newValue) {
        state.recipes_cart = newValue
    },
    SET_EXPECTED_OUTPUT(state, newValue) {
        state.expected_output = newValue
    },
    SET_ACTUAL_OUTPUT(state, newValue) {
        state.actual_output = newValue
    },
    SET_PRODUCTIONORDER_CART(state, newValue) {
        state.production_order_cart = newValue
    },
    SET_PRODUCTION_ORDERS(state, response) {
        handlePaginatedResponse(state.production_orders, response);
    },
    RESET_PRODUCTION_ORDERS_PAGINATION(state) {
        state.production_orders.data = [];
        state.production_orders.meta = { current_page: 1, from: 1, last_page: 1, per_page: 50, to: 0 };
    },
};

export const actions = {

    // Recipes Cart
    fetchRecipesCart({commit}) {
        axios.get(`recipes_cart`).then(ec_res => {
            commit('SET_RECIPE_CART', ec_res.data)
        })
    },

    addToRecipesCart({commit, dispatch}, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('recipes_cart', payload).then(() => {
            dispatch('fetchRecipesCart');
            let message = {'msg': `Ingredient added to cart successfully`}
            dispatch('notification/success', message, {root: true})
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = {'msg': "Error Adding Ingredient to cart " + error}
            dispatch('notification/error', message, {root: true})
        })
    },
    editRecipesCart({commit, dispatch}, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`recipes_cart/${payload.id}`, payload).then(() => {
            dispatch('fetchRecipesCart');
            let message = {'msg': `Ingredient ${payload.name} in cart updated successfully`}
            dispatch('notification/success', message, {root: true})
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = {'msg': "Error on updating Recipe Item in cart"}
            dispatch('notification/error', message, {root: true})
        })
    },
    deleteRecipesCart({commit, dispatch}, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`recipes_cart/${payload.id}`).then(() => {
            dispatch('fetchRecipesCart');
            let message = {'msg': `Ingredient ${payload.name} deleted from cart successfully`}
            dispatch('notification/success', message, {root: true})
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_RECIPE_CART', false)
            let message = {'msg': "Error on deleting Ingredient from cart " + error}
            dispatch('notification/error', message, {root: true})
        })
    },

    fetchRecipes({commit, dispatch}, payload) {
        commit('SET_SAVE_STATUS', true);

        let apiPayload = { ...payload };

        apiPayload.page = apiPayload.page ?? 1;
        apiPayload.per_page = apiPayload.per_page ?? 50;

        axios.post('fetchingredients',apiPayload).then(response => {
            commit('SET_RECIPE', response.data);
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_RECIPE', { data: [], meta:{} });
            commit('SET_SAVE_STATUS', false);
            let errorMsg = 'Failed to load recipes.';
            dispatch('notification/error', { msg: errorMsg }, { root: true });
        });
    },

    addRecipes({commit, dispatch}, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('recipes', payload).then((res) => {
            if (res.data.status == 200) {
                dispatch('fetchRecipesCart');
                let message = {'msg': `Ingredients for Item ${payload.name} added successfully`}
                dispatch('notification/success', message, {root: true})
            } else {
                let message = {'msg': res.data.message};
                dispatch('notification/error', message, {root: true})
            }
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = {'msg': "Error Adding Ingredients"}
            dispatch('notification/error', message, {root: true})
        })
    },
    editRecipes({commit, dispatch}, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`recipes/${payload.id}`, payload).then(() => {
            dispatch('fetchRecipes');
            let message = {'msg': `Ingredient ${payload.recipe} for product ${payload.product} updated successfully`}
            dispatch('notification/success', message, {root: true})
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = {'msg': "Error updating Ingredient"}
            dispatch('notification/error', message, {root: true})
        })
    },
    deleteRecipes({commit, dispatch}, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`recipes/${payload.id}`).then(() => {
            dispatch('fetchRecipes');
            let message = {'msg': `Ingredient ${payload.recipe} for product ${payload.product} deleted successfully`}
            dispatch('notification/success', message, {root: true})
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = {'msg': "Error in deleting Ingredient"}
            dispatch('notification/error', message, {root: true})
        })
    },
    async editProductQuantity({commit, dispatch}, payload) {
        commit("SET_SAVE_STATUS", true);
        await axios.put(`/recipes/products/${payload.product_id}`, payload).then(() => {
            dispatch('fetchRecipes');
            let message = {'msg': `Product quantity updated successfully`}
            dispatch('notification/success', message, {root: true})
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = {'msg': "Error updating Product Quantity"}
            dispatch('notification/error', message, {root: true})
        });
    },

    changeBase({commit, dispatch}, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`change_base/${payload.id}`, payload).then(() => {
            dispatch('fetchRecipes');
            let message = {'msg': `Ingredient ${payload.recipe} has been set as base for product ${payload.product}`}
            dispatch('notification/success', message, {root: true})
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = {'msg': "Error in setting base Ingredient"}
            dispatch('notification/error', message, {root: true})
        })
    },

    fetchExpectedOutput({commit}, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post(`fetch_expectedoutput`, payload).then(ec_res => {
            commit('SET_SAVE_STATUS', false);
            commit('SET_EXPECTED_OUTPUT', ec_res.data)
        })
    },

    fetchActualOutput({commit}, payload) {
        axios.post(`fetch_actualoutput`, payload).then(ec_res => {
            commit('SET_ACTUAL_OUTPUT', ec_res.data)
        })
    },

    editOutput({commit, dispatch}, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`expected_output/${payload.id}`, payload).then(() => {
            dispatch('fetchExpectedOutput');
            let message = {'msg': `Output for product ${payload.product} updated successfully`}
            dispatch('notification/success', message, {root: true})
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = {'msg': "Error updating Output"}
            dispatch('notification/error', message, {root: true})
        })
    },
    deleteOutput({commit, dispatch}, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`expected_output/${payload.id}`).then(() => {
            dispatch('fetchExpectedOutput');
            let message = {'msg': `Output for product ${payload.product} deleted successfully`}
            dispatch('notification/success', message, {root: true})
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = {'msg': "Error in deleting Output"}
            dispatch('notification/error', message, {root: true})
        })
    },

    confirmOutput({commit, dispatch}, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('expected_output', payload).then(() => {
            dispatch('fetchExpectedOutput');
            dispatch('fetchActualOutput');
            let message = {'msg': `Output for product ${payload.product} cofirmed successfully`}
            dispatch('notification/success', message, {root: true})
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = {'msg': "Error in cofirming Output"}
            dispatch('notification/error', message, {root: true})
        })
    },

    // Production Order Cart
    fetchProductionOrderCart({commit}) {
        axios.get(`productionorder_cart`).then(ec_res => {
            commit('SET_PRODUCTIONORDER_CART', ec_res.data)
        })
    },

    addToProductionOrderCart({commit, dispatch}, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('productionorder_cart', payload).then((res) => {
            if (res.status == 200) {
                dispatch('fetchProductionOrderCart');
                let message = {'msg': `Item added to cart successfully`}
                dispatch('notification/success', message, {root: true})                
            } else {
                let message = {'msg': res.data.message};
                dispatch('notification/error', message, {root: true})
            }     
            commit('SET_SAVE_STATUS', false);       
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = {'msg': "Error Adding Item to cart " + error}
            dispatch('notification/error', message, {root: true})
        })
    },

    editProductionOrderCart({commit, dispatch}, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`productionorder_cart/${payload.id}`, payload).then((res) => {
            if (res.status == 200) {
                dispatch('fetchProductionOrderCart');
                let message = {'msg': `Item ${payload.name} in cart updated successfully`}
                dispatch('notification/success', message, {root: true})
            } else {
                let message = {'msg': res.data.message};
                dispatch('notification/error', message, {root: true})
            }
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = {'msg': "Error on updating Item in cart"}
            dispatch('notification/error', message, {root: true})
        })
    },

    deleteProductionOrderCart({commit, dispatch}, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`productionorder_cart/${payload.id}`).then(() => {
            dispatch('fetchProductionOrderCart');
            let message = {'msg': `Item ${payload.name} deleted from cart successfully`}
            dispatch('notification/success', message, {root: true})
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_RECIPE_CART', false)
            let message = {'msg': "Error on deleting Item from cart " + error}
            dispatch('notification/error', message, {root: true})
        })
    },

    // Process order and Exit
    saveOrderExit({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post(`production_order`, data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchProductionOrderCart')
            if (response.status == 200) {
                let message = { 'msg': "Order Recorded successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to record Order" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchProductionOrderCart')
            let message = { 'msg': "Failed to record Order" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Production Orders
    fetchProductionOrders({commit, dispatch}, payload) {
        commit('SET_FILTER_STATUS', true);
        let apiPayload = { ...payload };
        apiPayload.page = payload.page || 1;
        apiPayload.per_page = payload.per_page || 50;

        axios.get(`production_order`,{
            params: payload
        }).then(ec_res => {
            commit('SET_FILTER_STATUS', false);
            commit('SET_PRODUCTION_ORDERS', ec_res.data)
        }).catch(() => {
            commit('SET_PRODUCTION_ORDERS', { data: [], meta:{} });
            commit('SET_FILTER_STATUS', false);
            let errorMsg = 'Failed to load production orders.';
            dispatch('notification/error', { msg: errorMsg }, { root: true });
        });
    },

    editProductionOrder({commit, dispatch}, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`production_order/${payload.id}`, payload).then((res) => {
            if (res.status == 200) {
                dispatch('fetchProductionOrders', payload.filterOrders);
                let message = {'msg': `Production order updated successfully`}
                dispatch('notification/success', message, {root: true})
            } else {
                let message = {'msg': res.data.message};
                dispatch('notification/error', message, {root: true})
            }            
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = {'msg': "Error on updating production order"}
            dispatch('notification/error', message, {root: true})
        })
    },

    deleteProductionOrder({commit, dispatch}, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`production_order/${payload.id}`).then((res) => {
            if (res.status == 200) {
                dispatch('fetchProductionOrders', payload.filterOrders);
                let message = {'msg': `Production order deleted successfully`}
                dispatch('notification/success', message, {root: true})
            } else {
                let message = {'msg': res.data.message};
                dispatch('notification/error', message, {root: true})
            }
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_RECIPE_CART', false)
            let message = {'msg': "Error on deleting production order " + error}
            dispatch('notification/error', message, {root: true})
        })
    },
};